import type { ReactNode } from 'react';

/**
 * Rank cell shared by the results tables and the history page. With `prev`
 * (the keyword's last recorded day) it appends a change badge — ↑N / ↓N /
 * IN (圏外→ランクイン) / OUT (圏外落ち) — and a "前回: N位" tooltip; without
 * it, just the rank (or 圏外).
 */
export function rankCell(value: number | null, prev?: number | null) {
  const rank = value === null ? <span className="muted">圏外</span> : <span className="rank">{value}</span>;
  if (prev === undefined) return rank;
  let delta: ReactNode = null;
  if (value !== null && prev === null) {
    delta = <span className="delta up">IN</span>;
  } else if (value === null && prev !== null) {
    delta = <span className="delta down">OUT</span>;
  } else if (value !== null && prev !== null && prev !== value) {
    const d = prev - value;
    delta = d > 0 ? <span className="delta up">↑{d}</span> : <span className="delta down">↓{-d}</span>;
  }
  return (
    <span title={`前回: ${prev === null ? '圏外' : `${prev}位`}`}>
      {rank}
      {delta}
    </span>
  );
}
